import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

// Gates /sales-dashboard. Access is granted via the Permissions Matrix entry
// "Reporting & Analytics::Sales team dashboard" — admin, leadership, finance,
// and sales managers by default.
export default function SalesDashboardRoute() {
  const { permissions } = useProductsContext();

  if (!permissions.canViewSalesDashboard) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
